import React from 'react';
import { IconChevronRight } from '@spotify-internal/encore-web/core';

import {
  NavBarPopoverLinkIconLeadingImage,
  NavBarPopoverLinkIconLeadingWrapper,
  NavBarPopoverLinkSubText,
  NavBarPopoverLinkText,
  NavBarPopoverLinkTextWrapper,
  NavBarPopoverNavigationItem,
  NavBarPopoverLink,
} from 'components/Masthead/Header/Popover/Shared';
import { MastheadLink } from 'lib/sanity/types';
import { urlForImage } from 'utils/sanity';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';

interface Props extends MastheadLink {
  nestingLevel: number;
  isDisabled?: boolean;
  onClick?: () => void;
}

export const NavBarPopoverListItem = ({
  target,
  title,
  href,
  image,
  nestingLevel,
  subtitle,
  isDisabled = false,
  onClick,
}: Props) => {
  const {
    verticalConfig: { verticalName },
  } = useServerSideConstants();
  const iconLeadingSrc = image && urlForImage({ source: image.asset, maxWidth: 16, vertical: verticalName });

  return (
    <NavBarPopoverNavigationItem isDisabled={isDisabled} onClick={onClick}>
      <NavBarPopoverLink
        target={target}
        href={href}
        iconLeading={
          iconLeadingSrc
            ? () => (
                <NavBarPopoverLinkIconLeadingWrapper>
                  <NavBarPopoverLinkIconLeadingImage imgUrl={iconLeadingSrc} alt="" />
                </NavBarPopoverLinkIconLeadingWrapper>
              )
            : undefined
        }
        level={nestingLevel}
        onClick={onClick}
        iconTrailing={() => <IconChevronRight size="small" />}
      >
        <NavBarPopoverLinkTextWrapper iconLeading={Boolean(iconLeadingSrc)} level={nestingLevel}>
          <NavBarPopoverLinkText isDisabled={isDisabled}>{title}</NavBarPopoverLinkText>
          {subtitle && <NavBarPopoverLinkSubText>{subtitle}</NavBarPopoverLinkSubText>}
        </NavBarPopoverLinkTextWrapper>
      </NavBarPopoverLink>
    </NavBarPopoverNavigationItem>
  );
};
